import {
  UpdateUserGlobalEnvironmentDocument,
  UpdateUserGlobalEnvironmentMutation,
  UpdateUserGlobalEnvironmentMutationVariables,
} from "@app/helpers/backend/graphql"
import { runMutation } from "@hoppscotch/common/helpers/backend/GQLClient"
import { SyncPlatformDef } from "@hoppscotch/common/platform/sync"

/**
 * Cloud-only `updateUserGlobalEnvironment`. The cloud backend split
 * global-env updates into a dedicated mutation; passing a global env id
 * to `updateUserEnvironment` is rejected with
 * `user_environment/env_does_not_exist`. The shared sync code in common
 * feature-detects this override and falls back to the legacy unified
 * mutation when absent (selfhost).
 */
const updateUserGlobalEnvironment = (id: string, variables: string) =>
  runMutation<
    UpdateUserGlobalEnvironmentMutation,
    UpdateUserGlobalEnvironmentMutationVariables,
    ""
  >(UpdateUserGlobalEnvironmentDocument, {
    id,
    variables,
  })()

/**
 * Cloud-only sync overrides. The shared sync layer expects fire-and-
 * forget callables — the curried `runMutation` thunk is invoked inside
 * the wrapper above so this stays a plain `(id, variables) => unknown`.
 */
export const def: SyncPlatformDef = {
  environment: {
    updateUserGlobalEnvironment,
  },
}
